@if (enableRedesignedBetCard && rewardTokenImage()?.src) {
    <img class="reward-token-image" width="12" height="12" priority [ngSrc]="rewardTokenImage()?.src" alt="{{ rewardTokenImage()?.alt }}" />
}
@if (!enableRedesignedBetCard) {
    <div class="my-bets-used-reward-token__icon">
        <vn-icon name="theme-success-i" size="12" />
    </div>
}
<div class="my-bets-used-reward-token__description">
    <div>{{ tokensTitle }}</div>
</div>
@if (hasDetails) {
    <div class="my-bets-used-reward-token__details">
        <div>{{ detailsText }}</div>
    </div>
}

@if (tokenSignPost()) {
    <div class="my-bets-used-reward-token__award-title">
        <div>{{ tokenSignPost().title }}</div>
    </div>
}
